export default "__VITE_ASSET__1abcc37a__"